import React from "react";
import Attendance from "../../components/admin/AttendanceList";


const AttendancePage = () => {
  
  return (
    <div >
      <Attendance />
    </div>
  );
};

export default AttendancePage;

